import styles from './Triforce.module.scss'

const Triforce = () => {
  return (
    <div className={styles.triforceImage}>
      <img src="/images/triforce.svg" alt="triforce" />
    </div>
  )
}

export default Triforce
